import { render, staticRenderFns } from "./CustomerUserButton.vue?vue&type=template&id=d1bca642"
import script from "./CustomerUserButton.vue?vue&type=script&lang=js"
export * from "./CustomerUserButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports